const defaultMaxSize = 5 * 1024 * 1024; // 5 * 1024 * 1024 === 5 MB in bytes

/**
 * Проверяет, что размер файла не превышает допустимый лимит (по умолчанию 5 МБ).
 * @param {File} file - Объект File.
 * @param {number} [maxSize] - Максимальный размер в байтах.
 * @returns {boolean} true, если размер файла в пределах лимита.
 */
const validateFile = (file, maxSize = defaultMaxSize) => file?.size <= maxSize;

export default validateFile;
